<template>
  <Portal to="side-menu">
    <div
      class="sticky overflow-hidden relative lg:mr-0"
      :style="{
        top: `${navHeight}px`,
        height: `calc(100vh - ${navHeight}px`,
        transition: 'all 0.5s ease',
        width: isOpen ? '200px' : 0,
        marginRight: isOpen ? '-200px' : 0,
      }"
    >
      <div
        class="absolute top-0 bottom-0 right-0 px-4 py-3 bg-gray-900 border-0 border-t-2 border-solid border-gray-1000"
        style="width: 200px"
      >
        <slot />
        <div class="fixed bottom-0" v-if="isNotDefaultDomain">
          <img
            src="https://cdn.sportsrecruits.com/logos/powered-by-SportsRecruits.svg"
            class="sr-powered-by my-3"
          />
        </div>
      </div>
    </div>
  </Portal>
</template>

<script>
import StickyBar from "@/components/StickyBar";
import SRCookies from "@/services/cookies";
import clientData from '@/services/clientData'

export default {
  components: { StickyBar },

  props: {
    toggled: { type: Boolean, required: true },
  },

  data() {
    return {
      navHeight: 58,
      manuallySetState: null,
    };
  },

  computed: {
    isOpen() {
      return this.wasManuallySet ? this.manuallySetState : this.isOpenByDefault;
    },

    wasManuallySet() {
      return this.manuallySetState !== null;
    },

    isOpenByDefault() {
      return this.$media("lg");
    },
    isNotDefaultDomain() {
      return !clientData('is_default_domain')
    },
  },

  watch: {
    toggled() {
      if (this.wasManuallySet) {
        this.manuallySetState = !this.manuallySetState;
      } else {
        this.manuallySetState = !this.isOpenByDefault;
      }
    },
  },
};
</script>